<script setup lang="ts">
import type { components } from "assets/api/openapi"

interface Props {
  options: components["schemas"]["TrainingTemplate"][]
  isUpToDate?: boolean
}

withDefaults(defineProps<Props>(), {
  isUpToDate: true,
})

const selectedTemplate =
  defineModel<components["schemas"]["TrainingTemplate"]>()
</script>

<template>
  <IffContentSection headline="Vorlage" :is-last-child="false">
    <div class="space-y-3">
      <div class="max-w-md">
        <UFormGroup
          name="selectedTemplate"
          label="Vergleichsausbildung für Stundenvergleich wählen"
        >
          <USelectMenu
            v-model="selectedTemplate"
            :options="options"
            option-attribute="templateName"
            by="templateName"
          />
        </UFormGroup>
      </div>
      <IffMessage
        variant="warning"
        v-if="
          selectedTemplate?.templateName === options[0]?.templateName &&
          !isUpToDate
        "
      >
        <IffCopyText size="small">
          Ihre eigene Vorlage enthält möglicherweise veraltete Fächer. Bitte
          überprüfen Sie die Daten.
        </IffCopyText>
      </IffMessage>
    </div>
  </IffContentSection>
</template>
